import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message, showTimer = false }) => {
  const [elapsedTime, setElapsedTime] = React.useState(0);

  React.useEffect(() => {
    if (!showTimer) return;

    const interval = setInterval(() => {
      setElapsedTime(prev => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [showTimer]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="loading-container">
      <div className="spinner-large"></div>
      <p className="loading-text">{message || 'Chargement du planning...'}</p>
      {showTimer && (
        <div className="loading-timer">
          <p className="timer-text">Temps écoulé: {formatTime(elapsedTime)}</p>
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${Math.min((elapsedTime / 300) * 100, 100)}%` }}
            ></div>
          </div>
          <p className="timer-hint">Temps estimé: 2-5 minutes</p>
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
